import React from "react"
import { Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartOptions,
  ChartData,
} from "chart.js"

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
interface ExamsBarChartProps {
  toppedStudent: number | null
  passedStudent: number | null
  failedStudent: number | null
}
const BarChart: React.FC<ExamsBarChartProps> = ({ toppedStudent, passedStudent, failedStudent }) => {
  const COLORS = ["#152456", "#07B42D", "#DC2626"]
  const labels = ["Topped", "Passed", "Failed"]
  const values = [toppedStudent, passedStudent, failedStudent]

  const data: ChartData<"bar"> = {
    labels,
    datasets: [
      {
        label: "",
        data: values,
        backgroundColor: COLORS,
        borderColor: COLORS,
        borderWidth: 1,
        borderRadius: 4,
        barThickness: 53,
      },
    ],
  }

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,

    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          color: "#333",
          font: { family: "Inter", size: 12, weight: 500, style: "normal" },
        },
        grid: { display: false },
      },
      x: {
        ticks: {
          color: "#333",
          font: { family: "Inter", size: 12, weight: 500, style: "normal" },
        },
        grid: { display: false },
      },
    },
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: { enabled: false },
    },
  }

  return (
    <div className="flex justify-between items-center w-full">
      <div className="w-[261px] h-[336px]  flex justify-center items-center  shadow-md rounded-lg  border bg-transparent rounded-lg">
        <div className="pl-1 w-[261px] h-[318px] flex justify-center items-center ">
          <Bar data={data} options={options} />
        </div>
      </div>
      <div className="flex flex-col bg-white w-1/2 ml-[1.25rem] space-y-2">
        {[
          { label: "Topped", color: "#152456", value: toppedStudent },
          { label: "Passed", color: "#07B42D", value: passedStudent },
          { label: "Failed", color: "#DC2626", value: failedStudent },
        ].map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center space-x-4 flex-1 min-w-0">
              <div className="w-[24px] h-[24px] rounded-[4px] shrink-0" style={{ backgroundColor: item.color }}></div>
              <span className="text-[#000] font-inter text-[14px] font-medium leading-normal truncate">
                {item.label}
              </span>
            </div>
            <div className="flex px-[10px] py-[6px] justify-center items-center rounded-[4px] bg-[#F9F9F9] w-[71px] h-[35px] shrink-0">
              <span className="text-[#000] font-inter text-[14px] font-medium leading-normal">
                {item.value ?? "0"}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BarChart
